import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import QuickActionCard from '../../../../components/Cards/QuickActionCard'
import { OpenInNewRounded } from '@mui/icons-material'

const DEFAULT_QUICK_LINK_COLOR = '#46D7E1'

// Cards are dark navy, so the accent colour must be light enough to read.
// Dark user-chosen colours fall back to the default accent.
const getAccentColor = (color) => {
  if (!/^#[0-9a-f]{6}$/i.test(color || '')) return DEFAULT_QUICK_LINK_COLOR

  const red = parseInt(color.slice(1, 3), 16)
  const green = parseInt(color.slice(3, 5), 16)
  const blue = parseInt(color.slice(5, 7), 16)
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255

  return luminance < 0.35 ? DEFAULT_QUICK_LINK_COLOR : color
}

const CustomQuickLinks = ({ teamActions }) => {
  const [links, setLinks] = useState([])
  useEffect(() => {
    API.get('/dashboard-data/custom-quick-links').then((res) => {
      if (res.status === 200 && res.data?.length) {
        setLinks((prev) => [...prev, ...res.data])
      }
    })
  }, [])

  return (
    <>
      {links.map((x) => (
        <QuickActionCard
          key={x._id}
          url={x.url}
          color={getAccentColor(x.color)}
          icon={OpenInNewRounded}
          label={x.title}
          largeSize={teamActions ? 12 : 6}
          onClick={() => window.open(x.url, '_open', 'noreferrer,noopener')}
        />
      ))}
    </>
  )
}

export default CustomQuickLinks
